
import { useState, useEffect } from 'react';

export const useNavbarScroll = () => {
  const [isScrolled, setIsScrolled] = useState(
    () => typeof window !== 'undefined' && window.scrollY > 50
  );

  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      // rAF : on ne lit le scroll + setState qu'une fois par frame au lieu
      // d'à chaque évènement de scroll. setState avec la même valeur = React
      // baille (pas de re-rendu). Listener passif = ne bloque jamais le scroll.
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        setIsScrolled(window.scrollY > 50);
        ticking = false;
      });
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return { isScrolled };
};
